/** The message that the embedded tool posts to the page around it (music24-website `coverMakerEmbed.ts`). */
export const COVER_MAKER_HEIGHT_MESSAGE = 'm24-cover-maker:height';

export interface CoverMakerHeightMessage {
  type: typeof COVER_MAKER_HEIGHT_MESSAGE;
  height: number;
}

/** The height message of the tool. The page clamps the value; the tool sends whole pixels. Pure. */
export function coverMakerHeightMessage(height: number): CoverMakerHeightMessage {
  return { type: COVER_MAKER_HEIGHT_MESSAGE, height: Math.max(0, Math.round(height)) };
}

/**
 * The origin that the height message goes to: the origin of the page around the frame, from
 * `document.referrer`; `*` when the browser gives no referrer. The message holds only a height, so
 * `*` gives nothing away. Pure.
 */
export function embedTargetOrigin(referrer: string): string {
  try {
    return referrer === '' ? '*' : new URL(referrer).origin;
  } catch {
    return '*';
  }
}

/**
 * The height that the embedded tool asks for: the editor needs room for the cover, the tools and
 * the inspector; a phone-wide frame stacks them, so it is taller. Pure.
 */
export function embedHeightFor(frameWidth: number): number {
  return frameWidth <= 900 ? 880 : 760;
}
